export { default } from "./NewsFeaturedMedia";
